import React from 'react'
import { ButtonTabs } from 'ui'
import { ForEachModel, useValue, ValueToCollection, WhenModelValue } from '@morningtrain/react-resources'
import CleaningCategorySectionTabs from 'pages/app/cleaning/partials/CleaningCategorySectionTabs'
import ConditionalStepCategorySection from 'pages/app/cleaning/partials/ConditionalStepCategorySection'

export default function PerformCheckupSteps () {
  const isCompleted = useValue('is_completed')

  return (
    <WhenModelValue name='steps'>
      <ValueToCollection name='steps'>
        <ButtonTabs classNames={['mb-8']}>
          <ForEachModel>
            <ValueToCollection name='steps'>
              <CleaningCategorySectionTabs />
            </ValueToCollection>
          </ForEachModel>
        </ButtonTabs>
        <ForEachModel>
          <ConditionalStepCategorySection isCompleted={isCompleted} />
        </ForEachModel>
      </ValueToCollection>
    </WhenModelValue>
  )
}
